import styles from './SearchHeading.module.scss';

function SearchHeading(): JSX.Element {
  return <h1 className={styles.heading}>Search Guide to OTC</h1>;
}

export default SearchHeading;
